<template>
  <v-slide-y-transition mode="out-in">
    <v-layout row wrap pa-3>
      <v-flex xs12 md8 >
        <v-layout column main-section>
          <CommentList :config="configCommentList"></CommentList>
        </v-layout>
      </v-flex>
      <v-flex xs12 md4 px-3>
        <v-layout column>
          <!-- Column of funds/balances -->
          <BalanceColumn></BalanceColumn>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-slide-y-transition>
</template>

<script>
  import axios from "axios";
  import BalanceColumn from "@/components/BalanceColumn";
  import Loader from "@/components/Loader";
  import CommentList from "@/components/CommentList";
  import router from '../router'

  export default {
    name:'dashboard',
    components:{
      BalanceColumn, Loader, CommentList
    },
    data () {
      return {
        configCommentList: {
          getApiUrl: "/api/fund/spendovation",
          addCommentApi: "/api/fund/commentovation",
          dashboardCommentList: true
        }
      }
    },
    computed:{
    },
    methods: {
    },
    beforeMount(){
    },
  }
</script>
